import { NUDGYT_AGENT_MESSAGE_TYPES } from '../constants/simulationConstants';
import { buildUserEmotionWsField } from './userEmotion';

/**
 * First recordable candidate, or '' when none are supported — callers must
 * treat '' as "unsupported browser" and skip getUserMedia.
 */
export function pickRecorderMimeType(candidates) {
  const recorder = window.MediaRecorder;
  if (typeof recorder?.isTypeSupported !== 'function') return '';

  return candidates?.find((type) => recorder.isTypeSupported(type)) ?? '';
}

/** Rejects clips too small or short to carry speech. */
export function isClipSendable({ size, durationMs, minClipBytes, minClipMs }) {
  return size >= minClipBytes && durationMs >= minClipMs;
}

/**
 * Builds the agent `audio_query` frame.
 *
 * `format` must be the recorder's own `mimeType` — Safari rewrites the
 * requested type and the data URL prefix has to match the bytes. Do not use
 * `utils.toDataUrl`: it infers wav/mpeg and would mislabel a webm clip.
 * `userEmotion` is omitted when absent or malformed, as in text_query.
 */
export function buildAudioQueryPayload({ base64Audio, format, userEmotion }) {
  const userEmotionField = buildUserEmotionWsField(userEmotion);

  return {
    type: NUDGYT_AGENT_MESSAGE_TYPES.AUDIO_QUERY,
    audio: `data:${format};base64,${base64Audio}`,
    format,
    mute_audio: false,
    ...(userEmotionField ?? {})
  };
}
